// src/components/LeafFall.js
import React, { useEffect, useState } from 'react';
import '../assets/Leaf.css';
import leafImage from '../assets/images/leaf.png';
import flowerImage from '../assets/images/leaf2.png';

const NUM_ITEMS = 28; // Total items (leaf + flower)

const getRandomNumber = (min, max) => Math.random() * (max - min) + min;

const getRandomImage = () => {
  return Math.random() > 0.5 ? leafImage : flowerImage;
};

const LeafFall = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const generatedItems = Array.from({ length: NUM_ITEMS }).map((_, index) => {
      const left = getRandomNumber(0, 100);
      const fallDuration = getRandomNumber(35, 25);
      const swayDuration = getRandomNumber(5, 10);
      const delay = getRandomNumber(0, 10);

      return {
        id: index,
        src: getRandomImage(),
        wrapperStyle: {
          left: `${left}vw`,
          animationDuration: `${fallDuration}s`,
          animationDelay: `${delay}s`,
        },
        itemStyle: {
          animationDuration: `${swayDuration}s`,
        },
      };
    });

    setItems(generatedItems);
  }, []);

  return (
    <div className="leaf-fall-container">
      {items.map((item) => (
        <div
          key={item.id}
          className="leaf-wrapper"
          style={item.wrapperStyle}
        >
          <img
            src={item.src}
            alt="Falling Item"
            className="falling-leaf"
            style={item.itemStyle}
          />
        </div>
      ))}
    </div>
  );
};

export default LeafFall;
